import React from 'react'
import { Switch, Route } from 'react-router-dom'

import Admin from './Admin/Admin'
import User from './User/User'
import NotFound from './NotFound'

const App = props => {
  return (
    <Switch>
      <Route path="/admin" component={Admin} />
      <Route path="/asiakkaat/:privatelink" component={User} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js